module.exports = __webpack_public_path__ + "img/Amir.9291bac5.jpeg";